import React from 'react'
import { DateTime } from 'luxon'
import { isEmpty } from 'lodash'
import { standardLabraDateFormat } from '@labrav/common'

import { ShowExpirationDateWithIcon } from '../common/components/ShowExpirationDateWithIcon/ShowExpirationDateWithIcon'
import { CloudMarketplace } from '../modules/productsListing/types'
import { SubscriptionObject } from '../modules/subscription/reducer'

export const getSubscriptionIdFromSubscription = (
  subscription: SubscriptionObject,
  cloud: CloudMarketplace
) => {
  switch (cloud) {
    case 'AWS':
      return subscription.subscriptionId
    case 'AZURE':
      return (
        subscription.subscriptionId || subscription.cloudMarketplaceContractId
      )
    case 'GCP':
    case 'REDHAT':
    default:
      return subscription.subscriptionId
  }
}

export const getExpirationDateFromSubscription = (
  subscription: SubscriptionObject,
  cloud: CloudMarketplace
): React.ReactNode => {
  switch (cloud) {
    case 'AWS': {
      return subscription.contractExpirationDate &&
        !isEmpty(subscription.contractExpirationDate) ? (
        <ShowExpirationDateWithIcon
          date={subscription.contractExpirationDate || ''}
          daysToCompare={30}
        />
      ) : (
        DateTime.fromISO(subscription.contractExpirationDate).toFormat(
          standardLabraDateFormat
        )
      )
    }
    case 'AZURE': {
      return subscription.contractExpirationDate &&
        !isEmpty(subscription.contractExpirationDate) ? (
        <ShowExpirationDateWithIcon
          date={subscription.contractExpirationDate || ''}
          daysToCompare={30}
        />
      ) : (
        '-'
      )
    }
    case 'GCP': {
      return subscription.contractExpirationDate &&
        !isEmpty(subscription.contractExpirationDate) ? (
        <ShowExpirationDateWithIcon
          expirePrefix="Ends in"
          date={subscription.contractExpirationDate || ''}
          daysToCompare={30}
          variant="split"
        />
      ) : (
        '-'
      )
    }
    case 'REDHAT':
      return '-'
    default:
      return subscription.contractExpirationDate || '-'
  }
}

export const getKeyCloudAccountForSubscription = (cloud: CloudMarketplace) => {
  switch (cloud) {
    case 'AWS':
      return 'awsAccountId'
    case 'AZURE':
      return 'buyerId'
    case 'GCP':
      return 'gcpAccountId'
    case 'REDHAT':
      return 'redhatAccountId'
    default:
      return 'awsAccountId'
  }
}

export const capitalizeFirstLetter = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1)

export const labraPermissionsHelpUrl =
  'https://help.labra.io/en/articles/permissions-in-labra'
